import React from 'react';
import { observer } from 'mobx-react-lite';
import { X } from 'lucide-react';
import AppointmentForm from '../dashboard/reservation-dashboard';
import { useTranslation } from 'react-i18next';
import {useCalendarViewModel} from "../../view-model/professional/calendar-view-model";


const ReservationCalendarModal: React.FC = () => {
  const calendarViewModel = useCalendarViewModel()
  const { t } = useTranslation();
  
  if (!calendarViewModel.getShowNewEventModal) return null;
  
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg max-w-md w-full max-h-[90vh] overflow-y-auto sm:my-0 my-4 mx-4">
        <div className="p-4 border-b border-gray-200 dark:border-gray-700 flex justify-between items-center">
          <h2 className="text-xl font-semibold">{t('calendar.newAppointment', 'Nouveau rendez-vous')}</h2>
          <button 
            onClick={() => calendarViewModel.closeNewEventModal()}
            className="rounded-full p-1 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
            aria-label="Fermer"
          >
            <X size={20} />
          </button>
        </div>
        
        <div className="p-4">
          <AppointmentForm
            onSuccess={() => calendarViewModel.closeNewEventModal()}
            onCancel={() => calendarViewModel.closeNewEventModal()}
            showTitle={false}
          />
        </div>
      </div>
    </div>
  );
};

export default observer(ReservationCalendarModal);
